import { useEffect } from "react";
import { SITE } from "./config";

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setJsonLd(id, data) {
  let el = document.getElementById(id);
  if (data === null) { if (el) el.remove(); return; }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function useSEO({ title, description, path = "/", image, jsonLd = null, noindex = false }) {
  useEffect(() => {
    const url = `${SITE.url}${path}`;
    const img = image || `${SITE.url}/og-image.jpg`;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", img);
    setMeta("property", "og:site_name", "Victoria Fuentes · Psicóloga Sanitaria");
    setMeta("property", "og:locale", "es_ES");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);

    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) { canon = document.createElement("link"); canon.rel = "canonical"; document.head.appendChild(canon); }
    canon.href = url;

    setJsonLd("jsonld-page", jsonLd);
    window.scrollTo(0, 0);
    return () => setJsonLd("jsonld-page", null);
  }, [title, description, path, image, jsonLd, noindex]);
}

export const businessSchema = {
  "@context": "https://schema.org",
  "@type": ["MedicalBusiness", "Psychologist"],
  name: `${SITE.name} — ${SITE.role}`,
  description: "Psicóloga sanitaria en Málaga especializada en ansiedad, depresión, duelo, terapia perinatal y psicología infantil.",
  url: SITE.url,
  telephone: `+34${SITE.phone}`,
  email: SITE.email,
  medicalSpecialty: "Psychiatric",
  priceRange: "€€",
  image: IMG_HERO(),
  address: {
    "@type": "PostalAddress",
    streetAddress: SITE.address,
    addressLocality: SITE.city,
    postalCode: SITE.postalCode,
    addressRegion: SITE.region,
    addressCountry: "ES",
  },
  openingHours: "Mo-Fr 09:00-14:00, Mo-Fr 16:00-20:00",
  areaServed: "Málaga",
};

function IMG_HERO() {
  return "https://static.prod-images.emergentagent.com/jobs/8ab517d1-955f-4652-9297-577ec4f8ee26/images/7817490e0278a10da37201d50af2a234efe8920a73c0907a8679b89fcdbb5340.jpeg";
}

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});
